export default "__VITE_ASSET__DhuFeqUU__"